import axios from 'axios'

export default {
  list(params) {
    return axios.get('/times', {params}).then(response => {
      return {success: true, data: response.data}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  export(params) {
    return axios.get('/times/export', {params, responseType: 'blob'}).then(response => {
      const type = response.headers['Content-Type']
      const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'report.xlsx'
      link.click()
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  get(id) {
    return axios.get('/times/' + id).then(response => {
      return {success: true, data: response.data}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  save(data) {
    return axios.post('/times', data).then(response => {
      return {success: true, data: response.data.entity}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  massiveSave(data) {
    return axios.post('/times/massive', data).then(response => {
      return {success: true}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  delete(id) {
    return axios.post('/times/' + id + '/delete').then(response => {
      return {success: true}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  },
  storeNotify(id, data) {
    return axios.post(`/times/${id}/notify`, data).then(response => {
      return {success: true}
    }, response => {
      throw {success: false, errors: response.errors}
    })
  }
}
